const GET_REQUEST_DATA = "GET_REQUEST_DATA";
const GET_FAILURE_DATA = "GET_FAILURE_DATA";
const GET_SUCCESS_DATA = "GET_SUCCESS_DATA";

const POST_REQUEST_DATA = "POST_REQUEST_DATA";
const POST_FAILURE_DATA = "POST_FAILURE_DATA";
const POST_SUCCESS_DATA = "POST_FAILURE_DATA";

const UPDATE_REQUEST_DATA = "UPDATE_REQUEST_DATA";
const UPDATE_FAILURE_DATA = "UPDATE_FAILURE_DATA";
const UPDATE_SUCCESS_DATA = "UPDATE_FAILURE_DATA";

const DELETE_REQUEST_DATA = "DELETE_REQUEST_DATA";
const DELETE_FAILURE_DATA = "DELETE_FAILURE_DATA";
const DELETE_SUCCESS_DATA = "DELETE_FAILURE_DATA";
//kids Product length
const GET_REQUEST_KIDS_PRODLENGTH = "GET_REQUEST_KIDS_PRODLENGTH";
const GET_FAILURE_KIDS_PRODLENGTH = "GET_FAILURE_KIDS_PRODLENGTH";
const GET_SUCCESS_KIDS_PRODLENGTH = "GET_SUCCESS_KIDS_PRODLENGTH";
//WOMENS Product length
const GET_REQUEST_WOMENS_PRODLENGTH = "GET_REQUEST_WOMENS_PRODLENGTH";
const GET_FAILURE_WOMENS_PRODLENGTH = "GET_FAILURE_WOMENS_PRODLENGTH";
const GET_SUCCESS_WOMENS_PRODLENGTH = "GET_SUCCESS_WOMENS_PRODLENGTH";
//MENS Product length
const GET_REQUEST_MENS_PRODLENGTH = "GET_REQUEST_MENS_PRODLENGTH";
const GET_FAILURE_MENS_PRODLENGTH = "GET_FAILURE_MENS_PRODLENGTH";
const GET_SUCCESS_MENS_PRODLENGTH = "GET_SUCCESS_MENS_PRODLENGTH";
//BEAUTY Product length
const GET_REQUEST_BEAUTY_PRODLENGTH = "GET_REQUEST_BEAUTY_PRODLENGTH";
const GET_FAILURE_BEAUTY_PRODLENGTH = "GET_FAILURE_BEAUTY_PRODLENGTH";
const GET_SUCCESS_BEAUTY_PRODLENGTH = "GET_SUCCESS_BEAUTY_PRODLENGTH";
export {
  GET_FAILURE_DATA,
  GET_REQUEST_DATA,
  GET_SUCCESS_DATA,
  POST_FAILURE_DATA,
  POST_REQUEST_DATA,
  POST_SUCCESS_DATA,
  UPDATE_FAILURE_DATA,
  UPDATE_REQUEST_DATA,
  UPDATE_SUCCESS_DATA,
  DELETE_FAILURE_DATA,
  DELETE_REQUEST_DATA,
  DELETE_SUCCESS_DATA,
  GET_REQUEST_KIDS_PRODLENGTH,
  GET_FAILURE_KIDS_PRODLENGTH,
  GET_SUCCESS_KIDS_PRODLENGTH,
  GET_REQUEST_MENS_PRODLENGTH,
  GET_FAILURE_MENS_PRODLENGTH,
  GET_SUCCESS_MENS_PRODLENGTH,
  GET_REQUEST_WOMENS_PRODLENGTH,
  GET_FAILURE_WOMENS_PRODLENGTH,
  GET_SUCCESS_WOMENS_PRODLENGTH,
  GET_REQUEST_BEAUTY_PRODLENGTH,
  GET_FAILURE_BEAUTY_PRODLENGTH,
  GET_SUCCESS_BEAUTY_PRODLENGTH,
};
